import plugins from '../plugins'
export default function (param) {
    plugins.call('request',param,param.success)
}